<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">

        <div class="col-12 mb-4">
            <v-card>
              <v-card-title>
                  <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                  ></v-text-field>
              </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="user_means_paiement_encours"
                        :search="search"
                        sort-by="name"
                        class="elevation-1"
                        :loading="!user_means_paiement_encours==undefined"
                        loading-text="Chargement en cours..."
                >




                <template v-slot:item._account_name="{ item }">
                  <span>{{item._account_name}} {{item._account_surname}}</span>
                </template>

                <template v-slot:item._type="{ item }">
                    <v-chip :color="getColorType(item._type)" dark>{{ item._type }}</v-chip>
                </template>

                <template v-slot:item._created_at="{item}">
                    {{ new Date(item._created_at).toLocaleDateString()}}
                </template>

                <template v-slot:item._user="{item}">
                    <span style="cursor: pointer" > {{ item._user._company}} </span>
               </template>

                  <template v-slot:item._means_paiement="{item}">
                    <div class="" >
                        <!-- <img width="50" height="50"
                        style="border-radius: 50%; border: 1px solid #82D0C9"
                        :src="item._means_paiement._file.substr(7)" alt=""> -->
                        <span class="ml-4">{{item._means_paiement._name}}</span>

                    </div >

                </template>


                    <template v-slot:item.actions="{ item }">
                        <div class="pt-5" >
                                    <v-btn @click="confirm(item)"  small color="primary">
                                        {{$t("usersmeanspaiementconfirmation.confirmed")}}
                                    </v-btn>

                                </div>
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>

        <customsnackbar :snackbar="customSnack.snackbar"
        :text="customSnack.text"
        :snackcolor="customSnack.snackcolor" :snackbBtnColor="customSnack.snackbBtnColor"
        :snacktimeout="customSnack.snacktimeout" > </customsnackbar>



    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import CountryFlag from 'vue-country-flag'
    import helpers from "../../../../mixins/helpers";
    import countries from '../../../../resources/countries.json'
    import $ from 'jquery'
    export default {
        components: {
            CountryFlag
        },
        mixins:[helpers(this)],
        label: "Pays",
        data() {
            return {
              customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                  },
                submitting: false,
                dialogShowDetail: false,
                valid: true,
                lazy: false,
                search: '',
                dialog: false,
                id: undefined,
                errors:undefined,
                note:"",
                 headers: [
                   {text: 'Moyen de paiement', value: '_means_paiement'},
                     {text: 'Pays', value: '_means_paiement._country._name'},
                    {text: 'Nom du compte', value: '_account_name'},
                    {text: 'Utilisateur', value: '_user'},
                    {
                        text: 'Type',
                        align: 'start',
                        sortable: false,
                        value: '_type',
                    },
                    {text: 'Numéro du compte', value: '_account_number'},
                    {text: 'Swift', value: '_swift'},
                    {text: 'Rib', value: '_rib'},
                    {text: 'Date', value: '_created_at'},
                    {text: '', value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    _swift: '',
                    _account_name: '',
                    _account_number: '',
                    _rib: '',
                    _means_paiement: '',
                    _user: '',
                    _id: 0,


                },
                defaultItem: {
                    _swift: '',
                    _account_name: '',
                    _account_number: '',
                    _rib: '',
                    _means_paiement: '',
                    _user: '',
                    _id: 0,

                },

                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || 'Code requis',
                ],
                code_iso_numeriqueRules: [
                    v => !!v || 'Code iso requis',
                ],

            }
        }
        ,
        computed: {

            ...mapState('user_means_paiements/', ['user_means_paiement_encours']),

        },
        mounted() {
            this.customSnack.snackbar = false;
            this.$vuetify.goTo(0);
            this.initialize()
        }
        ,
        watch: {

        }
        ,
        methods: {
              initialize () {

                let data = new FormData();
                data.append("state",false);
                data.append("id",this.$route.params.id?this.$route.params.id:'null');
                this.$store.dispatch('user_means_paiements/getUser_means_paiementConfirmations',data).then(response => {
                    console.log('user_means_paiements', response)
                });
                console.log('user_means_paiements', this.user_means_paiements)
            },

            confirm(item) {
                console.log("item",item._id)
               Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('usersmeanspaiementconfirmation.confirmwarning'),
                    confirmButtonText: this.$t('usersmeanspaiementconfirmation.confirmed'),
                    cancelButtonText: this.$t("cancel"),
                    showCancelButton: true,
                    cancelButtonColor:"#CCC",
                    confirmButtonColor:"#29B3A6"
                }).then(result => {
                    if (result.value) {
                         let data = new FormData();
                         data.append("id",item._id);
                          data.append("action","confirm");
                         this.$store.dispatch('user_means_paiements/confirm', data).then((response) => {
                          this.showSnackDefault(response);
                        })
                    }
                })


            },
            editItem(item) {
                this.editedIndex = this.countries.indexOf(item);
                this.editedItem._code = item._code.toUpperCase();
                this.editedItem._name = item._name;
                this.editedItem._file = item._flag;
                this.editedItem._code_iso_numerique = item._code_iso_numerique;
                this.editedItem._id = item._id;
                console.log(this.editedItem);
                this.dialog = true;
            }
            ,


            save(item,status,avis) {
                console.log('item',item);

                let VueBox = this;
                this.submitting = true;
                let data = new FormData();
                data.append("id", item._id);
                data.append("oldstatus", item._status);
                data.append("status", status);
                data.append("avis", avis!==''?avis:'Vide');
                let mineroute = 'reversements/updateStatus';

                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    VueBox.submitting = false;
                      this.showSnackDefault(response);
                        VueBox.close();

                })
            },

            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.countries.find(value => value._code === VueBox.editedItem.code)
                }
            },
            getColor(calories) {
                if (calories > 230) return 'red'
                else if (calories > 200) return 'orange'
                else return 'green'
            },
            getColorType (calories) {
                if (calories == "Banque") return 'green'
                else if (calories == "Mobile") return 'orange'
                else return 'green'
            },
            setCountryDetails(){
                let country =  countries.find(country=> country.iso2 == this.editedItem._code);
                this.editedItem._name = country.name;
                this.editedItem._code_iso_numerique = country.phone_code;
            },
            getColor2(calories) {
                if (calories == "en_attente") return 'orange'
                else if (calories == "success") return 'green'
                else if (calories == "en_cours") return 'primary'
                else return 'red'
            }

        },

        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
